import { render, staticRenderFns } from "./DaigouPay.vue?vue&type=template&id=bd5d2480&scoped=true"
import script from "./DaigouPay.vue?vue&type=script&lang=js"
export * from "./DaigouPay.vue?vue&type=script&lang=js"
import style0 from "./DaigouPay.vue?vue&type=style&index=0&id=bd5d2480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5d2480",
  null
  
)

export default component.exports